/**
 * Display formatting. Locale follows the UI language: apps call setFormatLocale() whenever i18next changes
 * language. Only used in clients; the server and engine never format money.
 */
import { parseMoneyCents } from './parse';

let locale = 'de-DE';
let eur = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' });
export function setFormatLocale(l: string) {
  locale = l;
  eur = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' });
}
export const formatLocale = () => locale;
export const euro = (cents: number | null | undefined) => (cents == null ? '–' : eur.format(cents / 100));
export const signedEuro = (cents: number) => (cents > 0 ? `+${euro(cents)}` : euro(cents));
/** ISO date (YYYY-MM-DD…) → localized date without timezone shifts. */
export const fmtDate = (d: string | null | undefined) => {
  if (!d) return '–';
  const [y = 1970, m = 1, day = 1] = d.slice(0, 10).split('-').map(Number);
  return new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' }).format(Date.UTC(y, m - 1, day));
};
/** Open end is rendered by the caller's translation (t('common:open')) and passed in. */
export const fmtRange = (from: string, to: string | null, openLabel: string) => `${fmtDate(from)} – ${to ? fmtDate(to) : openLabel}`;
/** Date + time in the same numeric date style as fmtDate ("22.09.2026, 11:00" / "22/09/2026, 11:00"). */
export const fmtDateTime = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleString(locale, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '–');
export const num = (n: number | null | undefined, digits = 2) => (n == null ? '–' : n.toLocaleString(locale, { maximumFractionDigits: digits }));
/** Decimal separator of the current format locale ("," for de, "." for en). */
export const decimalSeparator = () => ((1.5).toLocaleString(locale).includes(',') ? ',' : '.');
/** Parses typed money ("1.234,56", "1234.56", "1,234.56" in en) into cents via the shared parser. Null for invalid input. */
export const parseEuro = (s: string): number | null => parseMoneyCents(s, decimalSeparator());
/** Fraction string "n/d" → readable number. */
export const fracNum = (s: string) => {
  const [n, d] = s.split('/');
  return Number(n) / Number(d ?? 1);
};
